<template>
  <ValidationObserver
    ref="dropdownObserver"
    tag="div" >
    <ValidationProvider
      v-slot="{ errors }"
      :name="name"
      :rules="validators">
      <Title
        :title="title" />
      <multiselect
        :id="dropdownId"
        :ref="dropdownId"
        v-model="modelData"
        :placeholder="placeholder"
        class="flex-options hide-tags no-selected-background"
        :options="options"
        label="label"
        track-by="label"
        :multiple="false"
        :show-labels="false"
        :show-no-results="false"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        :allow-empty="!required"
        :preselect-first="required"
        :searchable="false" >
        <template
          slot="selection"
          slot-scope="{ values }">
          <span
            v-if="values.length"
            class="multiselect__single" >{{ values }}</span>
        </template>
        <template
          slot="singleLabel"
          slot-scope="selectedItem">
          <span
            v-if="true"
            class="multiselect__single"
            :class="{ 'image': selectedItem.option.image }"
            :style="{ backgroundImage: `url(${selectedItem.option.image})` }" >{{ selectedItem.option.label }}</span>
        </template>
        <template
          slot="option"
          slot-scope="props">
          <span
            class="greedy"
            :class="{ 'image': props.option.image }"
            :style="{ backgroundImage: `url(${props.option.image})` }" >{{ props.option.label }}</span>
          <SBIcon
            :icon="SBIconList.DONE_CIRCLE"
            :color="SBColors.bluePrimary"
            :size="13"/>
        </template>
      </multiselect>
      <ErrorInfoFooter
        :info="info"
        :errors="errors" />
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
import Multiselect from 'vue-multiselect';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import Title from '@/components/formElements/Title.form';
import randomString from '@/helpers/randomString';
import ErrorInfoFooter from '@/components/formElements/ErrorInfoFooter.form';

export default {
  name: 'Dropdown',
  components: {
    Multiselect,
    ErrorInfoFooter,
    SBIcon,
    Title,
  },
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    validators: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      default: 'Dropdown',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    subtitlePrefixIcon: {
      type: String,
      required: false,
      default: '',
    },
    info: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      initialized: false,
      modelData: null,
      // It matches the return format of the value like the input value.
      // Eg. if the input value is a match of the option then the whole option will be returned as value but if the input value is string matching the option.value parameter
      // then only value from the selected option will be returned.
      returnType: 'value',
      SBColors,
      SBIconList,
    };
  },
  computed: {
    dropdownId() {
      return `dropdown-${randomString()}`;
    },
  },
  watch: {
    modelData: {
      handler() {
        this.emitData();
      },
      immediate: true,
    },
    value() {
      this.setValue();
    },
  },
  mounted() {
    this.setValue();
    // if (this.schema.stepID) {
    //   this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
    //     this.$refs.dropdownObserver.validate();
    //   });
    // }
    this.$nextTick(() => {
      this.initialized = true;
    });
  },
  methods: {
    randomString,
    emitData(reset = false) {
      if (!this.initialized) return;
      if (!this.$refs.dropdownObserver) return;
      this.$refs.dropdownObserver.validate({ silent: true })
        .then((valid) => {
          this.$emit('status', {
            valid,
          });
          const returnValue = this.returnType === 'value' ? this.modelData.value : this.modelData;
          this.$emit('input', returnValue);
        })
        .finally(() => {
          if (reset) this.$refs.dropdownObserver.reset();
        });
    },
    setValue() {
      if (this.value) {
        const valueType = typeof this.value;
        switch (valueType) {
          case 'string':
            this.modelData = this.options.find(option => option.value === this.value);
            this.returnType = 'value'; // TODO we should also cover if the options are strings or numbers and not objects but there is no time now
            break;
          case 'object':
            this.modelData = this.options.find((option) => {
              const testEqual = this.$lodash.isEqual(this.sortObjectByKeys(option.value), this.sortObjectByKeys(this.value));
              if (testEqual) {
                this.returnType = 'value';
              }
              return testEqual;
            });
            if (!this.modelData) {
              this.modelData = this.options.find(option => this.$lodash.isEqual(this.sortObjectByKeys(option), this.sortObjectByKeys(this.value)));
            }
            break;
          default:
            this.modelData = this.options ? this.options[0] : null;
            break;
        }
      } else {
        this.modelData = this.options[0];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .flex-options {
  border-radius: 10px !important;

  .multiselect__select, .multiselect__tags {
    height: 34px !important;
    border-radius: 10px !important;
  }

  .multiselect__content-wrapper {
    border-radius: 10px !important;
  }
}

.flex-start-image {
  top: 1px;
  position: relative;
}
// .multiselect__content-wrapper {
//   position: fixed !important;
// }

// .multiselect__single {
//   padding: 50px 20px;
// }

// .multiselect__option .image,
// .multiselect__single .image {
//   padding-left: 22px;
//   background-repeat: no-repeat;
//   background-size: 14px 14px;
//   background-position: center left;
// }

::v-deep {
  .multiselect__option .image,
  .multiselect__single .image {
    padding-left: 22px;
    background-repeat: no-repeat;
    background-size: 14px 14px;
    background-position: center left;
  }
}
</style>
